import React from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/react';
import { Body, Heading2 } from '@qover/typography';
import { PrimaryButton, SecondaryButton } from '@qover/molecules';
import { Modal } from './Modal';

const ModalContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${Heading2} {
    margin-bottom: 40px;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const CloseButton = styled.div`
  text-decoration: underline;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.textQuote()};
  margin: 0 0 20px 0;
`;

const ActionContainer = styled.div`
  display: flex;
  button + button {
    margin-left: 20px;
  }
`;

type SuccessCancelModalProps = {
  description: React.ReactNode | React.ReactElement;
  onCancelClick: () => void;
  onSuccessClick: () => void;
  title: React.ReactNode | React.ReactElement;
};

export function SuccessCancelModal(props: SuccessCancelModalProps) {
  return (
    <Modal hideOverflow onClickOutside={props.onCancelClick}>
      <Container>
        <CloseButton
          data-test="general.successCancelModalClose"
          onClick={props.onCancelClick}
        >
          <Trans id="general.close" />
        </CloseButton>
      </Container>
      <ModalContainer>
        <Heading2
          as="div"
          style={{ marginBottom: '20px', textAlign: 'center' }}
        >
          {props.title}
        </Heading2>
        {props.description && (
          <Body style={{ marginTop: '0', marginBottom: '40px' }}>
            {props.description}
          </Body>
        )}
        <ActionContainer>
          <PrimaryButton onClick={props.onSuccessClick}>
            <Trans id="general.ok" />
          </PrimaryButton>
          <SecondaryButton onClick={props.onCancelClick}>
            <Trans id="general.cancel" />
          </SecondaryButton>
        </ActionContainer>
      </ModalContainer>
    </Modal>
  );
}
